import React, { useEffect, useRef, useState } from "react";
import { Container, Button, Row, Col, Input } from "reactstrap";

import {
  QuestionImport,
  QuestionPutTogetherCard,
  AssessmentCardDisplay,
} from "../../components";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import axios from "axios";

function AssessmentCreation() {
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [isNewQuestion, setIsNewQuestion] = useState(false);
  const [modal, setModal] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [assessmentData, setAssessmentData] = useState({});

  const toggle = () => setModal(!modal);

  const cardProps = {
    selectedCardId,
    setSelectedCardId,
    isNewQuestion,
    setIsNewQuestion,
    questions,
    setQuestions,
    loading,
    setLoading,
    error,
    setError,
  };

  const importProps = {
    setLoading,
    setError,
    setQuestions,
    toggle,
    modal,
  };

  return (
    <div className="page-content bg-white" style={{ minHeight: "100vh" }}>
      <Container fluid>
        <Row className="mb-3">
          <Col lg={12}>
            <h5>Create New Assessment</h5>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            {/* context provider for drag n drop with react-dnd */}
            <DndProvider backend={HTML5Backend}>
              <div className="mx-1" style={{ height: "750px" }}>
                <Row style={{ height: "100%" }}>
                  <Col md={4}>
                    <AssessmentCardDisplay {...cardProps} />
                  </Col>
                  <Col md={8}>
                    <QuestionPutTogetherCard onFormSubmit={setAssessmentData} />
                  </Col>
                </Row>
              </div>
            </DndProvider>
          </Col>
        </Row>

        <div style={{ height: "60px" }} />
      </Container>
    </div>
  );
}

export default AssessmentCreation;
